import * as React from "react";
type AllProps = {
  message: string;
  className?: string;
}

// Description: Custom form error message component 
function ErrorMessage(props: AllProps) {
  const { message, className } = props;
  return (
    <div className={`form-text text-danger ${className ?? ""}`}>{message}</div>
  );
}

export default React.memo(ErrorMessage);
